/* AUREN MODE — interacciones ligeras (sin dependencias) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(root, sel, fn) { (root || document).querySelectorAll(sel).forEach(fn); }

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.au-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Vídeos: autoplay en portada y play/pausa según visibilidad ---------- */
  function initVideos(root) {
    each(root, '.au-autoplay video, video[data-au-autoplay]', function (v) {
      v.muted = true; v.setAttribute('playsinline', '');
      var go = function () { if (!v.paused) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      go(); v.addEventListener('canplay', go, { once: true });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) go(); });
    });
    var vids = (root || document).querySelectorAll('.au-inview-video video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.muted = true; v.play(); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target; v.muted = true; v.setAttribute('playsinline', '');
        if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { v.loop = true; io.observe(v); });
  }

  /* ---------- Acordeones de una sola apertura ---------- */
  function initAccordions(root) {
    each(root, '.au-faq details', function (d) {
      if (d.dataset.auBound) return; d.dataset.auBound = '1';
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var group = d.closest('.au-faq');
        if (!group || group.dataset.single !== 'true') return;
        group.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- Pestañas + carruseles ---------- */
  function initRails(root) {
    each(root, '[data-au-tabs]', function (sec) {
      if (sec.dataset.auBound) return; sec.dataset.auBound = '1';
      var tabs = sec.querySelectorAll('[data-au-tab]');
      var panels = sec.querySelectorAll('[data-au-panel]');
      function active() { return sec.querySelector('[data-au-panel].is-active') || panels[0]; }
      function updateProgress() {
        var t = active() && active().querySelector('[data-au-track]');
        var bar = sec.querySelector('[data-au-progress]');
        if (!t || !bar) return;
        var max = t.scrollWidth - t.clientWidth;
        var ratio = t.clientWidth / t.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0) + '%)';
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-au-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
          panels.forEach(function (p) { var on = p.getAttribute('data-au-panel') === i; p.classList.toggle('is-active', on); p.hidden = !on; });
          initReveal(sec); updateProgress();
        });
      });
      sec.querySelectorAll('[data-au-track]').forEach(function (t) { t.addEventListener('scroll', updateProgress, { passive: true }); });
      var prev = sec.querySelector('[data-au-prev]'), next = sec.querySelector('[data-au-next]');
      function go(dir) { var t = active().querySelector('[data-au-track]'); if (t) t.scrollBy({ left: dir * t.clientWidth * 0.8, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      updateProgress(); window.addEventListener('resize', updateProgress);
    });
  }

  /* ---------- Compra el look: puntos ↔ lista ---------- */
  function initLooks(root) {
    each(root, '[data-au-look]', function (sec) {
      if (sec.dataset.auBound) return; sec.dataset.auBound = '1';
      var dots = sec.querySelectorAll('[data-au-hotspot]'), items = sec.querySelectorAll('[data-au-look-item]');
      function set(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-au-hotspot') === i); });
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-au-look-item') === i); });
      }
      dots.forEach(function (d) {
        var i = d.getAttribute('data-au-hotspot');
        d.addEventListener('mouseenter', function () { set(i); });
        d.addEventListener('click', function () {
          set(i);
          var it = sec.querySelector('[data-au-look-item="' + i + '"]');
          if (it && window.innerWidth < 990) it.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      items.forEach(function (it) { it.addEventListener('mouseenter', function () { set(it.getAttribute('data-au-look-item')); }); });
    });
  }

  /* ---------- Añadir al carrito rápido (tallas en tarjeta) ---------- */
  function addToCart(id, btn) {
    if (!id) return;
    btn.disabled = true; btn.classList.add('is-loading');
    var done = function (ok) {
      btn.classList.remove('is-loading');
      btn.classList.add(ok ? 'is-added' : 'is-error');
      setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added', 'is-error'); }, 1800);
    };
    var A = window.Shopify && window.Shopify.actions;
    if (A && A.updateCart) {
      A.updateCart({ lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }] })
        .then(function (r) {
          var ok = !(r && r.userErrors && r.userErrors.length);
          done(ok);
          // Solo se abre si estaba cerrado: desde "Te puede gustar" ya está abierto y no debe repetir la animación
          var drawer = document.querySelector('theme-drawer#cart-drawer');
          if (ok && A.openCart && !(drawer && drawer.hasAttribute('open'))) A.openCart();
        })
        .catch(function () { done(false); });
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); done(true); window.location.href = '/cart'; })
      .catch(function () { done(false); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-au-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-au-add'), btn);
  });

  /* ---------- Sugerencias del carrito: añadir la talla elegida ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-au-add-select]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var wrap = btn.closest('.au-crec__add'), field = wrap && wrap.querySelector('[data-au-variant]');
    if (field && field.value) addToCart(field.value, btn);
  });

  /* ---------- Carrito reservado: cuenta atrás de 10 min que se reinicia ---------- */
  if (window.customElements && !customElements.get('auren-cart-timer')) {
    customElements.define('auren-cart-timer', class extends HTMLElement {
      connectedCallback() { var self = this; this.tick(); this._i = setInterval(function () { self.tick(); }, 1000); }
      disconnectedCallback() { clearInterval(this._i); }
      tick() {
        var KEY = 'auren_cart_deadline', ms = (parseInt(this.dataset.minutes, 10) || 10) * 60000, now = Date.now(), dl = 0;
        try { dl = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
        if (!dl || dl <= now || dl - now > ms) { dl = now + ms; try { sessionStorage.setItem(KEY, String(dl)); } catch (e) {} }
        var left = Math.max(0, dl - now), m = Math.floor(left / 60000), sec = Math.floor((left % 60000) / 1000);
        var el = this.querySelector('[data-au-timer]');
        if (el) el.textContent = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
      }
    });
  }

  /* ---------- Panel de filtros y orden automático ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-au-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-au-open'));
      if (d && d.showModal) { d.showModal(); document.documentElement.style.overflow = 'hidden'; }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-au-close]');
    if (close) { var dlg = close.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('au-drawer')) e.target.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('au-drawer')) document.documentElement.style.overflow = '';
  }, true);
  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('form[data-au-autosubmit]');
    if (f) f.submit();
  });

  function init(root) { initReveal(root); initVideos(root); initAccordions(root); initRails(root); initLooks(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
